import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTASection() {
  return <section className="py-16 md:py-24 px-4 bg-carbon relative overflow-hidden" data-id="element-89">
      {/* Subtle background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[300px] md:w-[600px] h-[150px] md:h-[300px] bg-gold/5 blur-[80px] md:blur-[120px] rounded-full pointer-events-none" data-id="element-90"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-91">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-2xl md:text-4xl lg:text-5xl font-heading font-extrabold text-gold mb-6 md:mb-8 leading-tight" data-id="element-92">
          Solo aceptamos UN techador por zona geográfica.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex flex-col items-center" data-id="element-93">
          <p className="text-white text-base md:text-lg mb-8 md:mb-10 max-w-xl leading-relaxed" data-id="element-94">
            Si tu competidor directo agenda la cita antes que tú, el sistema
            será suyo y tú seguirás comprando sobras en Yelp.
          </p>

          <CTAButton text="VERIFICAR DISPONIBILIDAD EN MI ZONA" className="w-full md:w-auto text-sm md:text-lg px-6 md:px-10 py-4 md:py-5" data-id="element-95" />
        </motion.div>
      </div>
    </section>;
}